var map = {
	"./ar.svg": "73d3",
	"./de.svg": "e84b",
	"./en.svg": "8905",
	"./es.svg": "c23c",
	"./fa.svg": "2c6c",
	"./fr.svg": "5f88",
	"./it.svg": "3c5e",
	"./ja.svg": "1e6c",
	"./ko.svg": "5652",
	"./pt.svg": "6890",
	"./ru.svg": "86f9",
	"./tr.svg": "d79f",
	"./us.svg": "4745",
	"./zh.svg": "8e63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e65";